// extracted by mini-css-extract-plugin
module.exports = {"icon_style":"NewBaseIcon_icon_style__1Vij_"};